<template>
    <v-container fluid class="fill-height pa-0">
        <v-row class="fill-height ma-0">
            <div id="cesiumContainer"></div>
        </v-row>
    </v-container>
</template>
  
<script>
import { MapViewEventBus } from "../../helpers/mapview/events"
import * as Cesium from 'cesium';
import 'cesium/Build/Cesium/Widgets/widgets.css';

export default {
    name: 'CesiumViewer',
    props: {
        s3Public: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            viewer: null,
        };
    },
    methods: {
        async initializeCesium() {
            console.log("Map3dCesium initializeCesium")

            try {
                this.viewer = new Cesium.Viewer("cesiumContainer", {
                    timeline: false,
                    animation: false,
                    baseLayerPicker: false,
                    geocoder: false,
                    homeButton: false,
                    sceneModePicker: false,
                });
                this.viewer.scene.globe.show = false;
                this.viewer.scene.skyAtmosphere.show = false;

                const s3_tileset_url = `https://horus-platform.s3.amazonaws.com/${this.s3Public}outputs/3D_tiles/tileset.json`

                const tileset = await Cesium.Cesium3DTileset.fromUrl(
                    s3_tileset_url,
                    {
                        skipLevelOfDetail: true,
                        baseScreenSpaceError: 1024,
                        skipScreenSpaceErrorFactor: 16,
                        skipLevels: 1,
                        immediatelyLoadDesiredLevelOfDetail: false,
                        loadSiblings: false,
                        cullWithChildrenBounds: true,
                    }
                );

                tileset.cacheBytes = 1036870912
                console.log(`Total memory to use on Cache: ${tileset.cacheBytes / 1024 / 1024}`);

                this.viewer.scene.primitives.add(tileset);
                await this.viewer.zoomTo(tileset);

                tileset.tileLoad.addEventListener(function () {
                    console.log('A tile was LOADED. Memory used: ', tileset.totalMemoryUsageInBytes / 1024 / 1024);
                });

                tileset.tileUnload.addEventListener(function () {
                    console.log('A tile was unloaded from the cache. Memory used: ', tileset.totalMemoryUsageInBytes / 1024 / 1024);
                });

                tileset.allTilesLoaded.addEventListener(function () {
                    console.log('ALL tiles are loaded');
                    console.log(tileset.totalMemoryUsageInBytes / 1024 / 1024)
                });

            } catch (error) {
                console.log(`Error loading tileset: ${error}`);
            }
        },
    },
    created() {
        console.log("Map3dCesium created")
        MapViewEventBus.$on("map-3d-open", this.initializeCesium)
    },
    beforeDestroy() {
        MapViewEventBus.$off("map-3d-open", this.initializeCesium);
    }
}

</script>
  
<style scoped lang="scss">
.full-width {
    width: 100%;
}

.loading-text {
    color: #FFFFFF !important;
}

#cesiumContainer {
    width: 100%;
    height: 100vh;
}
</style>
  